<template>
  <div class="outage-container" v-if="isInOutage" >
    <div class="outage-message-content">
      <div class="outage-header" >
<div>e-Service is unavailable due to Scheduled Maintenance. Please try again shortly.</div>
      </div>
      <div class="outage-message">
        <div v-html="outageDescription"></div>
      </div>
       <div v-if="outageEndTime" class="outage-message-footer">
  System is schedule to be back online after {{(outageEndTime)}}
        </div>
      </div>
  </div>
</template>

<script>
import { OutageEvents } from "../outage-events";
import outageManager from "../outage-manager";

export default {
  name: "OutageOverdrop",
  async created() {
    OutageEvents.SubscribeForOutage(this.setAppToOutage);
    outageManager.startMonitoring();
  },
  data() {
    return {
      wentIntoOutage: false,
      isInOutage: false,
    };
  },
  computed: {
    outageDescription() {
      return this.$store.getters.outageSetting
        ? this.$store.getters.outageSetting.message
        : "";
    },
    outageEndTime() {
      return this.$store.getters.outageSetting ? new Date(this.$store.getters.outageSetting.endDateTime).toLocaleString("en-US") : '';
    },
  },
  methods: {
    setAppToOutage(outageStatus) {
      if (outageStatus) {
        this.isInOutage = true;
        this.wentIntoOutage = true;
      } else if (this.wentIntoOutage) {
        window.location.replace(window.location.origin);
      }
    },
  },
};
</script>
<style >

.outage-container {

   width: 100% !important;
    height: 100%;
     background: #d5d5d5cf;
    position: absolute;
    z-index: 1001;
    color: white;
    text-align: center;
    padding: 34px;
    background-size: cover;
  overflow: hidden;

}
.outage-container > div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.outage-message-content {
  background: white;
    padding: 10px;
    box-shadow: 0px 0px 5px 0px silver;
}

.outage-header {
     padding: 12px 25px;
    background: #2470a7;
    border-radius: 3px;
    font-size: 24px;
    margin-bottom: 20px;
}
.outage-message {
  color: black;
}
.outage-message-footer {
 color: #787878;
    font-size: 13px;
}
</style>
